import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import appconst from '@/lib/appconst';

interface BackDeliveryReceiptState extends ListState<any> {
}

class BackDeliveryReceiptMutations extends ListMutations<any>{

}
class BackDeliveryReceipt extends ListModule<BackDeliveryReceiptState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<BackDeliveryReceiptState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/DeliveryReceipt/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async add(context: ActionContext<BackDeliveryReceiptState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/DeliveryReceipt/Add', payload.data);
            return rep.data.result;
        },
        async getBatchNumberList(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/DeliveryReceipt/GetBatchNumberList?batchName=' + payload.data.batchNumber + "&storeId=" + payload.data.storeId);
            return rep.data.result;
        },
        getDeliveryReceip(state: any, data: any) {
            window.open(appconst.remoteServiceBaseUrl + "api/File/GetDeliveryReceip?storeId=" + data.data.storeId + "&batchName=" + data.data.batchName + "&logisticMethod=" + encodeURIComponent(data.data.logisticMethod) + "&userId=" + data.data.userId);
        },
    };
    mutations = {
        setCurrentPage(state: BackDeliveryReceiptState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackDeliveryReceiptState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const backDeliveryReceipt = new BackDeliveryReceipt();
export default backDeliveryReceipt;